import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Cards from './Cards';

const CardsLayout: React.FC = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                <div className={classNames(['tabs-panel', 'is-active'])} id="panel1c">
                    <h3 className={classNames(['padding-top-1', 'padding-bottom-1'])}>
                        {t('home:landing:valCareCardDesc')}
                    </h3>
                    <Cards renderCustomerInfo={true} renderButtons={true} />
                </div>
            </div>
        </React.Fragment>
    );
};

export default CardsLayout;
